import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import WowOverlay from '../Shared/WowOverlay';

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [overlay, setOverlay] = useState({
    open: false,
    state: 'success',
    message: ''
  });

  const timerRef = React.useRef(null);

  const hideOverlay = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setOverlay(prev => ({ ...prev, open: false }));
  }, []);

  const showOverlay = useCallback((state, message, duration = 3000) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    
    setOverlay({ open: true, state, message });
    
    // Non chiudere automaticamente se è un errore (come richiesto)
    if (state === 'error' || state === false) return;

    if (duration !== null) {
      timerRef.current = setTimeout(() => {
        setOverlay(prev => ({ ...prev, open: false }));
      }, duration);
    }
  }, []);

  const value = useMemo(() => ({
    showSuccess: (msg) => showOverlay('success', msg),
    showError: (msg) => showOverlay('error', msg, 4000),
    showLoading: (msg) => showOverlay('loading', msg, null),
    hideOverlay
  }), [showOverlay, hideOverlay]);

  return (
    <UIContext.Provider value={value}>
      {children}
      <WowOverlay 
        open={overlay.open} 
        state={overlay.state} 
        errorMessage={overlay.message} 
        onClose={hideOverlay}
      />
    </UIContext.Provider>
  );
};

UIProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useUI = () => useContext(UIContext);
 